/* eslint-disable max-classes-per-file */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
(() => {
  class ProductGrid extends HTMLElement {
    constructor() {
      super();
      this.collectionPage = document.querySelector("filter-and-sort");

      this.paginationLinks = this.querySelectorAll(".js-pagination-link");

      this.filterDelete = this.querySelector(".js-filter-delete-grid");
    }

    connectedCallback() {
      if (this.paginationLinks) {
        this.paginationLinks.forEach((link) => {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            const query = link.href.slice(link.href.indexOf("?"));
            const urlParams = new URLSearchParams(query);
            this.collectionPage.updateCollection(urlParams.get("page"));
          });
        });
      }

      if (this.filterDelete) {
        this.filterDelete.addEventListener("click", () => {
          document.querySelector(".js-filter-delete-desktop").click();
        });
      }
    }
  }

  if (!customElements.get("product-grid")) {
    customElements.define("product-grid", ProductGrid);
  }
})();
